import React, {useMemo, useState} from "react"
import {useAppSelector} from "../../../hooks/redux"
import {IDataTableTitle} from "../../../models"
import useWindowSize from "../../../hooks/useWindowSize"
import classes from "./OrderHistory.module.scss"
import Loading from "../Loading/Loading"
import OrderHistoryLine from "./components/OrderHistoryLine"
import ModalSuccess from "../modals/ModalSuccess/ModalSuccess"

function OrderHistory() {

  const windowSize = useWindowSize()
  const {list, totalCount, isLoading} = useAppSelector(state => state.client.orderHistory)
  const [modalEditSuccessShown, modalEditSuccessToggle] = useState(false)
  const [modalCopySuccessShown, modalCopySuccessToggle] = useState(false)

  const titles: IDataTableTitle[] = [
    {
      id: 1,
      name: "№ заявки"
    },
    {
      id: 2,
      name: "Откуда"
    },
    {
      id: 3,
      name: "Куда"
    },
    {
      id: 4,
      name: "Дата и время прибытия"
    },
    {
      id: 5,
      name: "Стоимость"
    },
    {
      id: 6,
      name: "Вес"
    },
    {
      id: 7,
      name: "Статус",
      className: classes.data_cell_status
    },
    {
      id: 8,
      name: "",
      className: classes.data_cell_menu
    },
  ]

  const headerFieldsTemplate = titles.map((item) => {

    const cellCls = [classes.data_cell]

    if (item.className) {
      cellCls.push(item.className)
    }

    return (
      <div
        className={cellCls.join(" ")}
        key={item.id}
      >
        <span>{item.name}</span>
      </div>
    )
  })

  const orderHistoryLines = useMemo(() => list.map(order => (
    <OrderHistoryLine
      key={order.id}
      order={order}
      editSuccess={modalEditSuccessToggle}
      copySuccess={modalCopySuccessToggle}
    />
  )), [list])

  const dataTemplate = !isLoading && totalCount > 0 &&
    <div className={classes.wrap}>
      <div className={classes.title}>История заявок</div>
      <div className={classes.data}>
        {windowSize.width >= 992 &&
          <div className={classes.data_header}>
            {headerFieldsTemplate}
          </div>
        }
        {orderHistoryLines}
      </div>
    </div>

  const emptyTemplate = !isLoading &&
    <div className={classes.empty}>По данному клиенту заявки отсутствуют</div>

  const modalUpdateSuccess = modalEditSuccessShown &&
    <ModalSuccess
      close={() => modalEditSuccessToggle(false)}
      title={"Заявка обновлена!"}
    />

  const modalCopySuccess = modalCopySuccessShown &&
    <ModalSuccess
      close={() => modalCopySuccessToggle(false)}
      title={"Копия заявки сохранена!"}
    />

  return (
    <>
      {isLoading && <Loading/>}
      {totalCount > 0 ? dataTemplate : emptyTemplate}
      {modalUpdateSuccess}
      {modalCopySuccess}
    </>
  )
}

export default OrderHistory